/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { B2BCondimentDto } from './condimentDto';
import { B2BAllergensDto } from './allergensDto';
import { B2BDietDto } from './dietDto';


export interface B2BCustomerPreferencesDto { 
    diets?: Array<B2BDietDto> | null;
    allergens?: Array<B2BAllergensDto> | null;
    condiments?: Array<B2BCondimentDto> | null;
}

